// extracted by mini-css-extract-plugin
export var notificationHost = "_mb-0";